import type { ComponentProps } from 'react';

const PendingClock = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        d="M7.4375 3.06201C7.4375 2.75029 7.68828 2.49951 8 2.49951C11.3141 2.49951 14 5.18545 14 8.49951C14 11.8136 11.3141 14.4995 8 14.4995C4.68594 14.4995 2 11.8136 2 8.49951C2 7.61123 2.19219 6.76982 2.53906 6.01279C2.67969 5.70342 2.84609 5.40811 3.03594 5.13154C3.03594 5.1292 3.03828 5.1292 3.03828 5.12686C3.25156 4.81279 3.49063 4.52217 3.75781 4.25732C3.97812 4.03701 4.33438 4.03701 4.55234 4.25732C4.77031 4.47764 4.77266 4.83389 4.55234 5.05186C4.33672 5.26748 4.13984 5.5042 3.96641 5.75732C3.96641 5.75967 3.96406 5.75967 3.96406 5.76201C3.46719 6.49326 3.1625 7.36748 3.12734 8.30967C3.125 8.37295 3.12266 8.43623 3.12266 8.49951C3.12266 11.1925 5.30469 13.3745 7.99766 13.3745C10.6906 13.3745 12.8727 11.1925 12.8727 8.49951C12.8727 5.99639 10.9883 3.93623 8.56016 3.65732V4.93701C8.56016 5.24873 8.30937 5.49951 7.99766 5.49951C7.68594 5.49951 7.43516 5.24873 7.43516 4.93701V3.06201H7.4375ZM5.72656 6.22607C5.94688 6.00576 6.30312 6.00576 6.52109 6.22607L8.39609 8.10107C8.61641 8.32139 8.61641 8.67764 8.39609 8.89561C8.17578 9.11357 7.81953 9.11592 7.60156 8.89561L5.72656 7.02061C5.50625 6.80029 5.50625 6.44404 5.72656 6.22607Z"
        fill="#928B82"
      />
    </svg>
  );
};

export default PendingClock;
